// utils.js
export const capitalizeFirstLetter = (string) => {
    if (!string) return string;
    return string
      .split(" ")  // Split string by space
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))  // Capitalize first letter of each word
      .join(" ");  // Join the words back into a single strin
  };